import React, { useState } from 'react';

function ImageUpload({ setImage }) {
  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
    if (e.target.files[0].type.startsWith('image')) {
      setImage(e.target.files[0]);
      setPreview(URL.createObjectURL(e.target.files[0]));
    } else {
      alert('Invalid file type. Please select an image file.');
    }
  };

  return (
    <div>
      <input type="file" accept="image/*" onChange={handleChange} />
      {preview && (
        <img
          className="w-[250] h-[150px] object-contain"
          src={preview}
          alt="Preview"
        />
      )}
    </div>
  );
}

export default ImageUpload;
